import { Typography, Button, Grid } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useNavigate } from 'react-router';



function MatrimonialPageHeader() {
  const navigate = useNavigate();

  const handleUser = () => {
    navigate('/matrimonial/add');
  } 
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Matrimonial
        </Typography>

      </Grid>
      <Grid item>
        <Button
          sx={{ mt: { xs: 2, md: 0 } }}
          variant="contained"
          onClick={handleUser}
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Create Matrimonial
        </Button>
      </Grid>
    </Grid>
  );
}

export default MatrimonialPageHeader;
